import { useQuery } from '@tanstack/react-query';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

export function useGetStudentParents(studentId: number | undefined) {
  return useQuery({
    queryKey: [ParentKey.STUDENT_PARENTS, studentId],
    queryFn: () => ParentService.getStudentParents(studentId as number).then((response) => response.data),
    enabled: typeof studentId === 'number',
  });
}
